import type { Nullable } from "../types";

/**
 * This function is used to guard a value and return null if the input is undefined or null.
 * @param value
 * @returns
 */
export function guardNull<T>(value: Nullable<T>): T | null {
	if (value === undefined) return null;
	return value;
}
